import React from "react";
import {menuService} from "../jwt/_services";

export const menuOptionsProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await menuService.search(0, 1000, null);

        listItems.data.sort((a, b) => a.name.localeCompare(b.name));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + ' - ' + item.name,
                    label: <label>{ item.code && (item.code?.toUpperCase() + ' - ')  } <b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await menuService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}